export default class Toggle {
  showPalliativeV1_5: boolean;
}



// WEBPACK FOOTER //
// ./src/models/toggle.ts